<template>
  <div
    class="sb-actions"
    data-sb-automation="sb-actions"
    data-sb-regression="sb-actions"
  >
    <template
      v-if="hasActionsDefaultSlot"
    >
      <!--
        @slot default actions slot
      -->
      <slot
        v-for="action in SbActionList.actions"
        :action="action"
      />
    </template>
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'SbActions',
  inject: {
    SbActionList: {
      default: { actions: [] },
    },
  },
  computed: {
    hasActionsDefaultSlot() {
      return this.$slots.default && this.$slots.default();
    },
  },
};
</script>

<style scoped lang='scss'>
@import '@src/components/ActionList/style/sb-actions.scss';
</style>
